import LogRocket from "logrocket";

export const initLogRocket = () => {
  if (typeof window !== "undefined") {
    const appId = process.env.NEXT_PUBLIC_LOG_ROCKET_APP_ID ?? "81ymm5/catalystweb";
    
    try {
      LogRocket.init(appId, {
        dom: {
          inputSanitizer: true,
        },
        console: {
          isEnabled: true,
        },
        network: {
          isEnabled: true,
        },
      });
    } catch (error) {
      console.error("LogRocket initialization error:", error);
    }
  }
};
